<template>
  <div id="app">
    <app-nav></app-nav>
    <div class="app-content">
      <vue-progress-bar></vue-progress-bar>
      <v-dialog name="signup-error">
        <div class="dib pa4 w-100">
          <p class="f2 fw5">
            Oh no... 😱
          </p>
          <p>
            
          </p>
        </div>
      </v-dialog>
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <app-footer></app-footer>
  </div>

</template>

<script>
import AppNav from './AppNav.vue'
import AppFooter from './AppFooter.vue'
export default {
  name: 'app',
  components: { AppNav, AppFooter },
  data () {
    return {
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/App.vue